import { render, staticRenderFns } from "./CreateLive.vue?vue&type=template&id=489fa2ac&scoped=true&"
import script from "./CreateLive.vue?vue&type=script&lang=js&"
export * from "./CreateLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489fa2ac",
  null
  
)

export default component.exports